import { Platform } from 'react-native';

/** One assistive announcement and a Tab stop on web (totals rows, cart lines, footer copy). */
export function receiptFocusableLabeledProps(accessibilityLabel: string) {
  return {
    accessible: true as const,
    accessibilityLabel,
    ...(Platform.OS === 'web' ? { tabIndex: 0 as const } : {}),
  };
}
